import { Divider, Typography, Grid, Select, MenuItem, InputLabel, Button } from "@material-ui/core";
import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { getDecks, updateHeaderInfo, logout, updateUserProfile, getUserDetails, submitCME, getSASPResidencyProgram, sendSASPResidentAccess } from "../actions";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { TextField, FormControl, FormGroup, FormControlLabel, Switch, Modal} from '@material-ui/core';
import { Link, Redirect } from "react-router-dom";
import HomeIcon from '@material-ui/icons/Home';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from '@material-ui/icons/Add';
import { SaspButton, CopyrightWidget, LoadingCard, AILegalStatementCard } from "../components";
import "../styles/deckCreationStyles.css";
import "../styles/masterStyles.css";
import { deviceData, getSASPURI, closeAlert, setContainer, getThisYear, remoteURL, createMarkup, clearLocalStorage, testerArr, alertNotification, hasLegal, setActiveNavigationWidget } from "../common";
import { isBrowser, isElectron } from 'react-device-detect';
import { ThemeConsumer } from "styled-components"; 

class Profile extends Component {
    state = {
        allowSearch: false,
        allowShare: false,
        allowLeaderboard: false,
        isDaily: false,
        displayName: "", 
        refresh: false,
        yst: 0,
        tl: 0,
        update: false,
        cme: {
            cmeBody : '',
            cmeProgram : '',
            cmeShow : 0,
            cmeTitle : ''
        },
        allowProgram: false,
        isResident: 0,
        isProgram: 0,
        show: false,
        program: null,
        open: false
    }

    componentDidMount = async () => {
        setActiveNavigationWidget("homeFooterIcon");
        document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});

        let _ap = false;

        if (typeof this.props.user_details.allowProgram !== 'undefined') {
            switch (this.props.user_details.allowProgram) {
                case -1:
                case 0:
                case 2: {
                    _ap = false;
                    break;
                }
                case 1: {
                    _ap = true;
                    break;
                }
                default: {
                    _ap = false;
                    break;
                }
            }
        }

        let bool = true;

        if (typeof this.props.program === 'undefined' || this.props.program === null) {
            bool = false;
            this.props.getSASPResidencyProgram({ mcid: this.props.auth_feedback.mcid, key: this.props.auth_feedback.key });
        }

        this.setState({
            ...this.state,
            allowSearch: (this.props.user_details.allowsearch) ? true : false,
            allowShare: (this.props.user_details.allowshare) ? true : false,
            allowLeaderboard: (this.props.user_details.allowleaderboard) ?  true : false,
            isDaily: (this.props.user_details.isDaily) ?  true : false,
            displayName: (typeof this.props.user_details.displayname) ? this.props.user_details.displayname : this.props.user_details.LabelName,
            yst: (this.props.user_details.yst) ?  this.props.user_details.yst : 0,
            tl: (this.props.user_details.tl) ?  Number(this.props.user_details.tl) : 0,
            tracking: deviceData(this.props.location, 'navigate'),
            isResident: this.props.user_details.isResident ? this.props.user_details.isResident : 0,
            isProgram: this.props.user_details.isProgram ? 1 : 0,
            hideOldData: this.props.user_details.hideOldData ? 1 : 0,
            allowProgram: _ap,
            show: bool,
            program: this.props.program
        });

        const { mcid, key } = this.props.auth_feedback;
        this.props.getUserDetails(mcid, key, deviceData(this.props.location, 'navigate'));

        await this.props.getDecks({ mcid: mcid, key: key });

        return this.props.updateHeaderInfo({
            route:"/profile", 
            name: "Profile", 
            iconTwo: 'menu', 
            iconOne: 'home',
            color: "#00567a"
        });
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.program !== this.props.program) {
            return this.setState({
                ...this.state,
                program: this.props.program
            })
        }

        if ( (prevState !== this.state) && (this.state.refresh) ) {
            if (prevProps.user_details === this.props.user_details) {
                this.props.getUserDetails( 
                    this.props.user_details.mcid, 
                    this.props.user_details.key,
                    deviceData(this.props.location, 'updated profile')
                );
            }

            this.setState({ refresh : false });
        }

        if (prevState.program !== this.state.program) {
            if (typeof this.state.program === 'undefined') {
                return this.setState({
                    ...this.state,
                    show: false,
                })
            }

            return this.setState({
                ...this.state,
                show: true,
            })
        }
    }

    updateUserProfile = async () => {
        let data = {
            mcid: this.props.user_details.mcid,
            key: this.props.user_details.key,
            allowSearch: this.state.allowSearch ? 1 : 0,
            allowShare: this.state.allowShare ? 1 : 0,
            allowLeaderboard: this.state.allowLeaderboard ? 1 : 0,
            isDaily: this.state.isDaily ? 1 : 0,
            hideOldData: this.state.hideOldData ? 1 : 0,
            displayName: this.state.displayName,
            yst: this.state.yst,
            tl: this.state.tl,
            allowProgram: this.state.allowProgram ? 1 : 0,
            isResident: this.state.isResident ? 1 : 0
        }

        await this.props.updateUserProfile(data);
        this.setState({ refresh : true });
    }

    handleSwitchChange = async (event) => {
        await this.setState({ ...this.state, [event.target.name]: event.target.checked });
        this.updateUserProfile();
    }

    handleNameChange = event => {
        this.setState({ ...this.state, displayName: event.target.value});
    };

    handleYSTChange = event => {
        this.setState({ ...this.state, yst: event.target.value});
    };

    handleTLChange = event => {
        this.setState({ ...this.state, tl: event.target.value});
    };

    handleTLSelect = event => {
        this.setState({ ...this.state, tl: event.target.value});
    };

    handleClose = () => {
        this.setOpen(false);
    };
    
    handleOpen = () => {
        this.setOpen(true);
    };

    setOpen = (bool) => {
        this.setState( { ...this.state, open: bool } )
    }

    setBool = (val) => {
        let r = false;
        if (val) { r = true; }

        return r;
    }

    submitCME = async (data) => {
        let obj = {
            mcid: this.props.user_details.mcid,
            key: this.props.user_details.key,
            qyear: data.qyear,
            gamemode: data.gamemode,
            tracking: deviceData(this.props.location, 'claimed CME')
        }

        if (typeof data.processed !== 'undefined') {
            obj.processed = data.processed
        }

        if (typeof data.claimed !== 'undefined') {
            obj.claimed = data.claimed
        }        

        await this.props.submitCME(obj);

        if (navigator.notification) {
            const msg = '\nYou have completed SASP ' + data.qyear + '.\n\nPlease login into AUAUniversity to claim your cme.';
            await navigator.notification.alert(
                msg, 
                closeAlert, 
                'Error', 
                'Close'
            );
        }

        this.setState({ ...this.state, update: !this.state.update, refresh: true });
        return null
    }

    claimCME = async (data) => {
        if (window.cordova) {
            if (window.cordova.InAppBrowser) {
                let type = '_blank';
                if (isElectron) {
                    type = '_system';
                }
                const uri = await getSASPURI(data.qyear);
                return window.cordova.InAppBrowser.open(uri, type, 'location=yes');
            } else {
                this.submitCME(data);
            }            
        }  else {
            this.submitCME(data);
        }
    }

    setContainer = (bool) => {
        return { padding: "0 16px 32px", margin: "calc(env(safe-area-inset-top) + 56px) 0 64px", width: "calc(100% - 32px)", overflowY: "auto", backgroundColor: "white" };

        if (bool) {
            if (isBrowser && !isElectron) {
                return { padding: "0 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto", backgroundColor: "white" };
            } else {
                return { padding: "0 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto", backgroundColor: "white" };
            }
        } else {
            if (isBrowser && !isElectron) {
                return { padding: "0 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto", backgroundColor: "white" };
            } else {
                return { padding: "0 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto", backgroundColor: "white" };
            }
        }
    }

    handleCMEClose = () => {
        return this.setState({
            ...this.state,
            cme: {
                cmeText: '',
                cmeTitle: '',
                cmeProgram: '',
                cmeShow: 0
            }
        });
    }

    mapModalBody = () => {
        return (
            <div style={{
                backgroundColor: "#fff",
                border: "2px solid #00567a",
                borderRadius: "8px",
                padding: "8px 16px 16px",
                maxHeight: `78vh`,
                width: '78vw',
                overflow: 'auto',
                outline: "none",
            }}
            id='homeDIV'
            >
                {/* <Typography className="homeDividerText margin-top-8">{this.state.cme.cmeTitle}</Typography>
                <Divider className="SASPTestsDivider"  style={{margin: "0", width: "calc(100% - 16px)"}}/> */}

                <div 
                    id="cme-modal-description" 
                    style={{fontSize: "1rem"}}
                    dangerouslySetInnerHTML={createMarkup(
                        this.state.cme.cmeBody
                    )}
                />

                {this.state.cme.cmeProgram === 'SASP21'
                    ? (
                        <div style={{
                            display:"flex",
                            flexDirection:"column",
                            justifyContent:"flex-start",
                            alignItems:"flex-start",
                            width:"100%",
                            margin: "8px 0"
                        }}>
                            <div className="width100 margin-bottom-16">
                                
                                <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/education_council_disclosures_2021.pdf')} >
                                    <Typography className="homeDividerText" style={{padding: "0 0 8px", fontSize:"0.8rem"}}>
                                        Education Council Disclosures
                                    </Typography>
                                    View Disclosures
                                </Link>

                                <Divider className="margin-top-8" />
                            </div>

                            <div className="width100 margin-bottom-16">
                                <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/coi_review_disclosures_2021.pdf')} >
                                    <Typography className="homeDividerText" style={{padding: "0 0 8px", fontSize:"0.8rem"}}>
                                        COI Review Work Group Disclosures
                                    </Typography>
                                    View Disclosures
                                </Link>

                                <Divider className="margin-top-8" />
                            </div>

                            <div className="width100 margin-bottom-16">
                                <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/abu_exam_committee_2021.pdf')} >
                                    <Typography className="homeDividerText" style={{padding: "0 0 8px", fontSize:"0.8rem"}}>
                                        ABU Examination Committee Disclosures
                                    </Typography>
                                    View Disclosures
                                </Link>

                                <Divider className="margin-top-8" />
                            </div>
                        </div>
                    ) : null
                }
            </div>
        )
    }

    confirmClear = () => {
        if (navigator.notification) {
            function onConfirm (index) {
                index = Number(index);

                switch (index) {
                    case 1: {
                        clearLocalStorage();
                        alertNotification({
                            message : 'Local Data is removed',
                            buttonName : 'Ok',
                            title : 'SASP'
                        })
                        return null;
                    }
                    default: {
                        return false;
                    }
                }
            }

            navigator.notification.confirm(
                `Are you sure that you want to reset your local data?`,
                onConfirm,
                'SASP'
            )
        }
    }

    handleAccess = (obj) => {
        if (obj.state.accesslevel === 2) {

            return this.props.history.push(obj);
        } else {
            this.setState({
                ...this.state,
                loading: true,
            })

            this.props.sendSASPResidentAccess(obj.data);
        }

        return null;
    }

    render () {
        let resObj = [];
        let cnt = 1;

        for (let deck of this.props.deckList) {
            let temp = {}
            let per = Math.trunc(Number(deck.totaAnswered) / Number(deck.totalQuestions) * 100);
            temp.name = (deck.deckname ? deck.deckname : "Deck " + cnt);
            temp.result = (per <= 100 ? per : '100') + '%';
            temp.isSpaced = (Number(deck.isspaced) === 1 ? 'Yes' : "No");
            temp.isOpen = (Number(deck.gameMode) === 3 ? 'Yes' : "No");
            temp.gameMode = deck.gameMode;
            temp.deckID = deck.deckID;
            resObj.push(temp);
            cnt++;
        }
        
        let t = this.props.user_details.authorizedyears.split(',');
        let subs = this.props.user_details.authorizedyears;
        if (Number(t[0]) < Number(t[t.length - 1])) {
            subs = '';
            cnt = 0;
            let arr = t.reverse();

            for (const i of arr) {
                if (cnt) {
                    subs += ', ';
                } else {
                    cnt++;
                }
                subs += i.trim();
            }
        } else {
            subs = subs.replace(/,/gi, ', ');
        }

        let cmeText = [];
        // let c = 0;
        let _arr = this.props.user_details.cmeYears;
        for (let i of _arr) {
            let tcme = '20' + i.programID.replace('SASP', '') + ' (' + i.programID + ')';
            let _tobj = i;
            _tobj.title = tcme;

            cmeText.push(_tobj)
        }

        if (this.state.show) {
            return (
                <>
                    <AILegalStatementCard in={hasLegal()} />
                    <div className="aua-overflow" style={this.setContainer(isBrowser)}>
                        <Typography className="homeDividerText">Manage Profile</Typography>

                        <div className="aua-container" style={{paddingBottom:"0"}}>
                            <Grid item xs={12} className="margin-bottom-12">
                                <TextField
                                    label="Display Name"
                                    value={this.state.displayName}
                                    onChange={this.handleNameChange}
                                    onBlur={this.updateUserProfile}
                                    style={{width: "100%"}}
                                />
                            </Grid>

                            <Grid item xs={12} className="margin-bottom-12">
                                <TextField
                                    label="Years Since Training"
                                    value={this.state.yst}
                                    onChange={this.handleYSTChange}
                                    onBlur={this.updateUserProfile}
                                    style={{width: "100%"}}
                                />
                            </Grid>

                            {/* <Grid item xs={12} className="margin-bottom-12">
                                <TextField
                                    label="Teaching Load"
                                    value={this.state.tl}
                                    onChange={this.handleTLChange}
                                    onBlur={this.updateUserProfile}
                                    style={{width: "100%"}}
                                />
                            </Grid> */}

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="tl-select-label">
                                        Teaching Load
                                    </InputLabel>
                                    <Select
                                        labelId="tl-select-label"
                                        id="tl-select"
                                        open={this.state.open}
                                        onClose={this.handleClose}
                                        onOpen={this.handleOpen}
                                        value={this.state.tl}
                                        label="Teaching Load"
                                        onChange={this.handleTLSelect}
                                        onBlur={this.updateUserProfile}
                                    >
                                        <MenuItem value={0}>N/A</MenuItem>
                                        <MenuItem value={1}>No Teaching</MenuItem>
                                        <MenuItem value={2}>Light Teaching</MenuItem>
                                        <MenuItem value={3}>Medium Teaching</MenuItem>
                                        <MenuItem value={4}>Heavy Teaching</MenuItem>
                                        <MenuItem value={9}>Unclassified</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <div className="flex-row-between width100" style={{alignItems: "flex-start"}}>
                                <div>
                                    {typeof this.state.hideOldData !== 'undefined'
                                        ? (
                                            <Grid item xs={12} >
                                                <div className="row-set">
                                                    <FormControl component="fieldset">
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={<Switch 
                                                                    checked={this.setBool(this.state.hideOldData)}  
                                                                    onChange={this.handleSwitchChange} 
                                                                    name="hideOldData" />}
                                                                label="Hide Questions more than 5 years old."
                                                            />
                                                        </FormGroup>
                                                    </FormControl>
                                                </div>
                                            </Grid>
                                        ) : null
                                    }

                                    <Grid item xs={12}>
                                        <div className="row-set">
                                            <FormControl component="fieldset">
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={<Switch 
                                                            checked={this.setBool(this.state.allowSearch)} 
                                                            onChange={this.handleSwitchChange} 
                                                            name="allowSearch" />}
                                                        label="Allow Search"
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div className="row-set">
                                            <FormControl component="fieldset">
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={<Switch 
                                                            checked={this.setBool(this.state.allowShare)} 
                                                            onChange={this.handleSwitchChange} 
                                                            name="allowShare" />}
                                                        label="Allow Sharing"
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div className="row-set">
                                            <FormControl component="fieldset">
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={<Switch 
                                                            checked={this.setBool(this.state.allowLeaderboard)}  
                                                            onChange={this.handleSwitchChange} 
                                                            name="allowLeaderboard" />}
                                                        label="Show on Leaderboard"
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} className="margin-bottom-24">
                                        <div className="row-set">
                                            <FormControl component="fieldset">
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={<Switch 
                                                            checked={this.setBool(this.state.isDaily)}  
                                                            onChange={this.handleSwitchChange} 
                                                            name="isDaily" />}
                                                        label="Show Question of Day"
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </div>
                            </div>
                        </div>

                        <Typography className="homeDividerText margin-top-8">Account Details</Typography>

                        <div className="aua-container" style={{paddingBottom:"24px"}}>
                            <Grid item xs={12} className="">
                                <TableContainer component={Paper}>
                                    <Table style={{width: "100%"}} aria-label="simple table">
                                        <TableBody>
                                            <TableRow key="SASPSubs">
                                                <TableCell>Subscriptions</TableCell>
                                                <TableCell 
                                                    align="left"
                                                    style={{
                                                        wordBreak: "break-word",
                                                        textAlign: "left"
                                                    }}
                                                >
                                                    {subs}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="userName">
                                                <TableCell>Reviewed CME Details</TableCell>
                                                <TableCell align="left">
                                                    <div className="flex-col width100">
                                                        {cmeText.map((cme) => (
                                                            <div className="width100">
                                                                <Button className="text-blue" onClick={() => {
                                                                    console.log(this.props.user_details);
                                                                    console.log(cme);
                                                                    this.setState({
                                                                        ...this.state,
                                                                        cme: {
                                                                            cmeTitle: cme.title,
                                                                            cmeProgram: cme.programID,
                                                                            cmeShow: 1,
                                                                            cmeBody: cme.CMEContent
                                                                        }
                                                                    })
                                                                }} >
                                                                    View {cme.title}
                                                                </Button>
                                                            </div>  
                                                        ))}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </div>

                        {this.state.isResident
                            ? (
                                <>
                                    <Typography className="homeDividerText margin-top-8">Residency Program</Typography>

                                    <div className="flex-col-start width100" style={{alignItems: "flex-start"}}>
                                        <div className="aua-container" style={{paddingBottom:"24px"}}>
                                            <Grid item xs={12} className="">
                                                <TableContainer component={Paper}>
                                                    <Table style={{width: "100%"}} aria-label="simple table">
                                                        <TableBody>
                                                            <TableRow key="Residency">
                                                                <TableCell>Residency Program</TableCell>
                                                                <TableCell 
                                                                    align="right"
                                                                    style={{
                                                                        wordBreak: "break-word",
                                                                        textAlign: "right"
                                                                    }}
                                                                >
                                                                    {this.props.user_details.residencydata.program}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                        </div>

                                        <Grid item xs={12} className="margin-bottom-24">
                                            <div className="row-set">
                                                <FormControl component="fieldset">
                                                    <FormGroup>
                                                        <FormControlLabel
                                                            control={<Switch 
                                                                checked={this.setBool(this.state.allowProgram)}  
                                                                onChange={this.handleSwitchChange} 
                                                                name="allowProgram" />}
                                                            label="Share results data with Residency Program"
                                                        />
                                                    </FormGroup>
                                                </FormControl>
                                            </div>
                                        </Grid>
                                    </div>
                                </>
                            ) : null
                        }


                        {this.state.isProgram && this.state.program !== null && Array.isArray(this.state.program.residents)
                            ? (
                                <>
                                    <Typography className="homeDividerText margin-top-8">Program Residents</Typography>

                                    <div className="flex-col-start width100" style={{alignItems: "flex-start"}}>
                                        <div className="aua-container" style={{paddingBottom:"24px"}}>
                                            <Grid item xs={12} className="">
                                                <TableContainer component={Paper}>
                                                    <Table style={{width: "100%"}} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow key="Residency">
                                                                <TableCell>Name</TableCell>
                                                                <TableCell 
                                                                    align="right"
                                                                    style={{
                                                                        wordBreak: "break-word",
                                                                        textAlign: "right"
                                                                    }}
                                                                >
                                                                    Access Level
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>

                                                        <TableBody>
                                                            {this.state.program.residents.map((item, index) => {
                                                                let target = {
                                                                    pathname: '/residents',
                                                                    state: {
                                                                        programid: this.state.program.programid,
                                                                        residentid: item.residentid,
                                                                        mcid: this.props.user_details.mcid,
                                                                        key: this.props.user_details.key,
                                                                        accesslevel: item.accesslevel,
                                                                        pathname: '/residents',
                                                                    } 
                                                                }
                                                                return (
                                                                    <TableRow key="Residency">
                                                                        <TableCell>
                                                                            <Link className="text-blue" onClick={() => {
                                                                                return this.handleAccess(target);
                                                                            }}>
                                                                                {item.displayName}
                                                                            </Link>
                                                                        </TableCell>
                                                                        <TableCell 
                                                                            align="right"
                                                                            style={{
                                                                                wordBreak: "break-word",
                                                                                textAlign: "right"
                                                                            }}
                                                                        >
                                                                            <Link className="text-blue" onClick={() => {
                                                                                return this.handleAccess(item, target);
                                                                            }}>
                                                                                {item.accessleveltext}
                                                                            </Link>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                        </div>
                                    </div>
                                </>
                            ) : null
                        }

                        <Typography className="homeDividerText margin-top-8">SASP Test Status</Typography>

                        <div className="aua-container margin-bottom-24" style={{paddingBottom:"0"}}>                        
                            <Grid item xs={12}>
                                <TableContainer className="" component={Paper}>
                                    <Table style={{width: "100%"}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Year</TableCell>
                                                <TableCell align="center">Completed</TableCell>
                                                {/* <TableCell align="center">Claimed</TableCell>
                                                <TableCell align="center">Processes</TableCell> */}
                                                <TableCell align="center">Open Book</TableCell>
                                                <TableCell align="center">Closed Book</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.props.user_details.cme.map((row) => (
                                                <TableRow>
                                                    <TableCell>{row.year}</TableCell>
                                                    {row.completed || 1 === 1
                                                        ? (
                                                            <TableCell align="center">
                                                                {row.completed ? 'Yes' : 'No'}
                                                            </TableCell>
                                                        )
                                                        : (
                                                            <TableCell align="center">
                                                                {/* <Link
                                                                    className="text-blue"
                                                                    onClick={ () => this.submitCME({
                                                                        qyear: row.year,
                                                                        gamemode: 1
                                                                    }) }
                                                                > */}
                                                                    {row.completed ? 'Yes' : 'No'}
                                                                {/* </Link> */}
                                                            </TableCell>
                                                        )
                                                    }

                                                    {/* {row.completed && row.claimed
                                                        ? (
                                                            <TableCell align="center">
                                                                {row.claimed ? 'Yes' : 'No'}
                                                            </TableCell>
                                                        )
                                                        : (
                                                            <TableCell align="center">
                                                                <Link
                                                                    className="text-blue"
                                                                    onClick={ () => this.claimCME({
                                                                        qyear: row.year,
                                                                        gamemode: 1,
                                                                        claimed: 1
                                                                    }) }
                                                                >
                                                                    {row.claimed ? 'Yes' : 'No'}
                                                                </Link>
                                                            </TableCell>
                                                        )
                                                    }

                                                    <TableCell align="center">
                                                        {row.processed ? 'Yes' : 'No'}
                                                    </TableCell> */}

                                                    <TableCell align="center">
                                                        <Link
                                                            to={{
                                                                pathname : '/testResultScreen',
                                                                testYear : row.year,
                                                                gameMode : 1
                                                            }}
                                                            className={'text-blue text-center'}
                                                        >View</Link>
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Link
                                                            to={{
                                                                pathname : '/testResultScreen',
                                                                testYear : row.year,
                                                                gameMode : 2
                                                            }}
                                                            className={'text-blue text-center'}
                                                        >View</Link>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </div>
                        
                        
                        {/* <Typography className="homeDividerText margin-top-8">Decks</Typography> */}

                        <div className="aua-container margin-bottom-24" style={{paddingBottom:"0"}}>                        
                            {/* <Grid item xs={12}>
                                <TableContainer className="" component={Paper}>
                                    <Table style={{width: "100%"}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Name</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Spaced</TableCell>
                                                <TableCell align="center">Open</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {resObj.map((row) => (
                                                <TableRow key={row.name}>
                                                    <TableCell>
                                                        <Link
                                                            to={{
                                                                pathname: "/questionScreen",
                                                                deckID: row.deckID,
                                                                gameMode: (typeof row.gameMode !== 'undefined' ? row.gameMode : 3)
                                                            }}
                                                            className="text-blue"
                                                        >
                                                            {row.name}
                                                        </Link>
                                                    </TableCell>
                                                    <TableCell align="center">{row.result}</TableCell>
                                                    <TableCell align="center">{row.isSpaced}</TableCell>
                                                    <TableCell align="center">{row.isOpen}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid> */}

                            <div className="aua-container flex-row-between" >
                                {testerArr.includes(this.props.auth_feedback.mcid)
                                    ? (
                                        <SaspButton
                                            className="text-white"
                                            onClick={() => this.confirmClear()}
                                            style={{minWidth: "125px"}}
                                        >
                                            Clear Local Data
                                        </SaspButton>
                                    ) : (
                                        <><p>&nbsp;</p></>
                                    )
                                }
                                
                                <div
                                    onClick={this.props.logout}
                                    style={{minWidth: "125px", color: "var(--aua-app-theme-color)", backgroundColor: "white", fontWeight: "700", fontSize:"1.05em", padding: "0 16px"}}
                                >
                                    Log Out 
                                </div>
                            </div>

                            <CopyrightWidget 
                                style={{width: "auto;"}}
                                begin={2012}
                                year={getThisYear()}
                                textAlign={'center'}
                                className="margin-top-8 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                            />
                        </div>

                    </div>

                    <Modal
                        open={this.state.cme.cmeShow}
                        onClose={this.handleCMEClose}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{
                            display:"flex",
                            flexDirection:"column",
                            justifyContent:"center",
                            alignItems:"center",
                            position: 'absolute',
                        }}
                    >
                        {this.mapModalBody()}
                    </Modal>   
                
                </>
            );
        } else {
            return (
                <LoadingCard />
            )
        } 
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details, program } = state.auth;
    const { headerText, iconOne, iconTwo } = state.style;
    const { deckList } = state.decks;
    return {
        headerText,
        iconOne,
        iconTwo,
        deckList,
        auth_feedback,
        user_details,
        program
    };
};

const ProfileScreen = connect(mapStateToProps, { 
    updateHeaderInfo, getDecks, logout, updateUserProfile, getUserDetails, submitCME, getSASPResidencyProgram, sendSASPResidentAccess
})(
    Profile
);

export { ProfileScreen };
